<section class="u-text-center">
  <h1>{{ 'ON_BOARDING.STEPPER.THIRD_STEP.ALMOST_DONE' | translate }}</h1>
  <p>{{ 'ON_BOARDING.STEPPER.THIRD_STEP.COMPLETE_TRAINING' | translate }}</p>
  <app-spinner [showText]="true" *ngIf="isLoadingVideos; else videosLoaded"></app-spinner>
  <ng-template #videosLoaded>
    <app-boarding-video *ngFor="let video of videos; trackBy: trackByItems" [video]="video"></app-boarding-video>
  </ng-template>
</section>
